export default {
    topics: [
        {
            title: ' FillWorkflow ',
            href: 'sm-olapAggregate-FillWorkflow.html',
            attributes: { 'data-id': 'sm-olapAggregate-FillWorkflow' },
            menu: { hasChildren: false },
            tocID: 'sm-olapAggregate-FillWorkflow-d66e819',
            topics: [],
        },
        {
            title: ' InvalidAggregate ',
            href: 'sm-olapAggregate-InvalidAggregate.html',
            attributes: { 'data-id': 'sm-olapAggregate-InvalidAggregate' },
            menu: { hasChildren: false },
            tocID: 'sm-olapAggregate-InvalidAggregate-d66e827',
            topics: [],
        },
    ],
};

